/**
 * Document download banner — reveal only.
 *
 * @package HelloElementorChild
 */

import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';

export function initCamstDocumentBanner(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-document-banner]'));
  } else if (scope.matches && scope.matches('[data-camst-document-banner]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-document-banner]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstDocumentBannerInit === '1') {
      return;
    }

    root.dataset.camstDocumentBannerInit = '1';
    initCamstReveal(root);
  });
}

export function teardownCamstDocumentBanner(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-document-banner]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-document-banner]'));

  roots.forEach(function (root) {
    teardownCamstReveal(root);
    delete root.dataset.camstDocumentBannerInit;
  });
}
